import { render } from "./AeracaoPage.vue?vue&type=template&id=4e5dba4a&scoped=true"
import script from "./AeracaoPage.vue?vue&type=script&lang=js"
export * from "./AeracaoPage.vue?vue&type=script&lang=js"

import "./AeracaoPage.vue?vue&type=style&index=0&id=4e5dba4a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5dba4a"]])

export default __exports__